import { computed, watch, ref, toValue } from 'vue';
import { useLoyalty } from '~/composables/loyalty/useLoyalty';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import { useUser } from '~/composables/user/useUser';
import { extractDataAttributes, isDataFromAEMAvailable } from '~/modules/productPerks/utils';

const LOYALLIST_BANNER_KEY = 'PDP_FREESHIP_LOYALLIST';
const BEAUTY_BANNER_KEY = 'PDP_FREESHIP_BEAUTY';
const BANNER_KEY = 'PDP_FREESHIP';

const getBannerType = (isUserNonLoyalist: boolean, isBeauty: boolean, isSignedIn: boolean) => {
  if (isSignedIn && !isUserNonLoyalist) {
    return LOYALLIST_BANNER_KEY;
  }
  if (isBeauty) {
    return BEAUTY_BANNER_KEY;
  }
  return BANNER_KEY;
};

export default function useLoyalList() {
  const forceRerenderKey = ref(0);
  const { bannerDetails } = useCommonProductGetters();
  const { beautyFlag } = useProductFlags();
  const { isUserNonLoyalist } = useLoyalty();
  const { isSignedIn } = useUser();

  const bannerType = computed(() => getBannerType(isUserNonLoyalist.value, beautyFlag, isSignedIn.value));
  const banner = computed(() => toValue(bannerDetails)?.[bannerType.value]?.[0].alt || '');
  const AEMData = computed(() => extractDataAttributes(banner.value));
  const isShippingBanner = computed(() => AEMData.value?.shipping !== 'false');
  const isDataFromAEM = computed(() => !!banner.value && isDataFromAEMAvailable(AEMData.value));

  watch(
    () => bannerType.value,
    () => {
      // Force re-render when banner type changes
      forceRerenderKey.value += 1;
    },
  );

  return {
    forceRerenderKey,
    banner,
    AEMData,
    isDataFromAEM,
    isShippingBanner,
  };
}
